import React, { useMemo, useEffect } from 'react'
import { useSelector } from 'APP/Hooks/redux'
import { View } from 'react-native'
import styled from 'styled-components/native'

// Components
import Banner from 'APP/Components/Banner'
import NoticeBarContainer from 'APP/Components/NoticeBarContainer'
import Cobranding from 'APP/Components/Cobranding'
import DialogueBranding from 'APP/Components/DialogueBranding'
import sprigClient from 'APP/Services/Sprig'

import { useAppComponentMapper } from 'APP/Lib/ContentHelpers'
import { RootScreens } from 'APP/Lib/Enums'
// Styling
import Styles from './style'
import { ResponsiveScrollView } from 'APP/Converse/Layout'
import useScreenView from 'APP/Hooks/useScreenView'
import { popToNative } from 'APP/BrownfieldBridge/BrownfieldBridgeInternal'
import { isEmbeddedEnvironment } from 'APP/BrownfieldBridge/utils'
import HomeBannerButton from 'APP/Components/HomeBannerButton'

const BrandingBanner = styled.View`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-color: ${({ theme }) => theme.colors.elementsBorder};
  border-top-width: 1px;
`

// TODO: Switch ScrollView for FlatList, use with scrolltoindex()
// use https://reactnative.dev/docs/flatlist#scrolltoindex

const selectAppComponents = (state) => {
  const screens = state?.content?.layout?.data?.screens
  return screens?.find((screen) => screen?.mobile_scene_key === RootScreens.today)?.components
}

const TodayScreen = ({ navigation, route }) => {
  const appComponents = useSelector(selectAppComponents)
  const mapAppComponent = useAppComponentMapper()
  const { isSmallScreen } = useScreenView()

  const eligibleComponents = useMemo(
    () =>
      appComponents?.reduce((eligibleComponents, appComponent) => {
        const Component = mapAppComponent(appComponent)

        if (Component) {
          eligibleComponents.push({ Component, appComponent })
        }

        return eligibleComponents
      }, []),
    [appComponents, mapAppComponent]
  )

  const renderComponent = ({ Component, appComponent }) => {
    // Launchpad needs some special styling
    if (appComponent.mobile_component_name === 'AppLaunchpad') {
      return (
        <Component
          key={appComponent.id}
          testId={appComponent.mobile_component_name}
          style={[Styles.appComponentVerticalSpacing, Styles.launchpad]}
          navigation={navigation}
          route={route}
        />
      )
    } else {
      return (
        <Component
          key={appComponent.id}
          appComponent={appComponent}
          testId={appComponent.mobile_component_name}
          style={Styles.appComponentVerticalSpacing}
          navigation={navigation}
          route={route}
        />
      )
    }
  }

  useEffect(() => {
    sprigClient.track('MX_APP_LAUNCH')
  }, [])

  /* Logic note:
    <Banner /> is explicitly defined twice, as we want it to render
    1. Inside the scrollable view when on a small screen
    2. outside of the scrollable view when on a large screen
  */

  return (
    <View style={Styles.container} testID="TODAY_SCREEN">
      {isEmbeddedEnvironment() && <HomeBannerButton onPress={() => popToNative(true)} />}
      {!isSmallScreen && <Banner />}
      <ResponsiveScrollView
        wrapIntoView={true}
        footer={
          <View style={Styles.footer}>
            <Cobranding style={Styles.brandingContainer} />
            <BrandingBanner>
              <DialogueBranding />
            </BrandingBanner>
          </View>
        }
      >
        {isSmallScreen && <Banner />}
        {eligibleComponents?.map(renderComponent)}
      </ResponsiveScrollView>
      <NoticeBarContainer inline />
    </View>
  )
}

export default TodayScreen
